import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled, { keyframes } from "styled-components";

export const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to   { opacity: 1; transform: translateY(0); }
`;

export const RealEstateCardWrapper = styled.div`
  width: 340px;
  height: 450px;
  display: flex;
  flex-direction: column;
`;

export const RealEstateCardContainer = styled(RealEstateCardWrapper)`
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 6px 20px rgba(0,0,0,0.1);
  overflow: hidden;
  transition: transform 0.4s ease, box-shadow 0.4s ease;
  animation: ${fadeIn} 0.5s ease-out;

  &:hover {
    transform: translateY(-8px) scale(1.02);
    box-shadow: 0 12px 32px rgba(0,0,0,0.15);
  }
`;

export const CarouselContainer = styled.div`
  position: relative;
  width: 100%;
  height: 200px;
  overflow: hidden;
  background: #000;
`;

export const CarouselWrapper = styled.div<{ translateX: number }>`
  display: flex;
  width: 100%;
  height: 100%;
  transform: translateX(${({ translateX }) => translateX}%);
  transition: transform 0.5s ease;
`;

export const MediaSlide = styled.div`
  min-width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
`;

export const MediaItem = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const VideoItem = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: #000;
`;

export const NavButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0,0,0,0.5);
  color: white;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: background 0.3s;

  &:hover { background: rgba(0,0,0,0.7); }
  &.prev { left: 12px; }
  &.next { right: 12px; }
`;

export const DotsContainer = styled.div`
  position: absolute;
  bottom: 12px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 6px;
  z-index: 10;
`;

export const Dot = styled.div<{ active: boolean }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${({ active }) => (active ? '#fff' : 'rgba(255,255,255,0.5)')};
  transition: all 0.3s;
  cursor: pointer;
  &:hover { background: #fff; }
`;

export const VideoOverlay = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0,0,0,0.6);
  border-radius: 50%;
  width: 72px;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  z-index: 5;
`;

export const BusinessNameOverlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(to top, rgba(0,0,0,0.75), transparent);
  padding: 20px 18px 14px;
  font-size: 1.3rem;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.5px;
  text-shadow: 0 2px 6px rgba(0,0,0,0.4);
  z-index: 5;
`;

export const DetailsContainer = styled.div`
  padding: 18px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex-grow: 1;
`;

export const DetailItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.95rem;
  color: #444;
`;

export const DetailIcon = styled(FontAwesomeIcon)`
  color: #6c63ff;
  font-size: 1rem;
`;

export const DetailText = styled.span`
  font-weight: 600;
  color: #222;
`;

export const PriceTag = styled.div`
  background: linear-gradient(135deg, #6c63ff, #48c6ef);
  color: #fff;
  padding: 6px 14px;
  border-radius: 50px;
  font-size: 0.9rem;
  font-weight: bold;
  align-self: flex-start;
  box-shadow: 0 4px 12px rgba(108,99,255,0.3);
`;